module.exports = __webpack_public_path__ + "0af5d249/img/dollar-icon.35c9d638.svg";